import type { Assignment } from '@/types'

export type JobCrewAssignmentContext = {
  openCount: number
  crewTemplateId: string | number
}

export function getJobCrewAssignmentContext(assignments: Assignment[]): JobCrewAssignmentContext | null {
  const openCrewSlots = assignments.filter(
    (assignment) => !assignment.worker_id && assignment.crew_template_slot,
  )
  if (openCrewSlots.length === 0) {
    return null
  }

  const crewTemplateId = openCrewSlots.find((assignment) => assignment.crew_template_id)?.crew_template_id
  if (!crewTemplateId) {
    return null
  }

  return {
    openCount: openCrewSlots.length,
    crewTemplateId,
  }
}

export function groupAssignmentsByJob(assignments: Assignment[]): Array<[string, Assignment[]]> {
  const groups = new Map<string, Assignment[]>()
  for (const assignment of assignments) {
    const jobId = String(assignment.job_id)
    groups.set(jobId, [...(groups.get(jobId) ?? []), assignment])
  }
  return Array.from(groups.entries())
}
